<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <!--<button v-show="this.query.page == 1" class="fl-button" type="button" v-on:click="refreshingChange()"><i v-bind:class=this.refreshing_icon></i></button>-->
          </div>
          <h1>Munkaidő nyilvántartás</h1>

          <div class="row">
            <div class="col-xs-12">
              <h2>Kereső</h2>
            </div>
            <div class="col-xs-4">
              <comboboxV2 id="groups" label="Csoport" name="groups" :options="search.groups.items" v-on:input="groupChange"/>
            </div>
            <div class="col-xs-4">
              <comboboxV2 id="workers" label="Dolgozó" name="workers" :options="search.workers.items" v-on:input="workerChange" :value="search.workers.selected"/>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="years" label="Év" name="years" :options="search.years.items" v-on:input="yearChange" :value="curr_year"/>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="months" label="Hónap" name="months" :options="search.months.items" v-on:input="monthChange" :value="curr_month"/>
            </div>
          </div>

          <div v-if="query.worker && query.worker!='0'" class="table-with-title">
            <h2>Jelenlét</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Nap</th>
                  <th>Érkezés</th>
                  <th>Távozás</th>
                  <th>Bent töltött percek száma</th>
                  <th>Bent töltött órák száma</th>
                  <th>Mozgások</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(day, i) in days">
                  <td>{{i+1}}</td>
                  <td>{{day.first_enter?trimDate(day.first_enter):'-'}}</td>
                  <td>{{day.last_leave?trimDate(day.last_leave):'-'}}</td>
                  <td>{{day.spent_min}}</td>
                  <td>{{day.spent_hour}}</td>
                  <td>
                    <section v-for="(event, j) in day.events"><span style="color:green">BE:</span> {{trimDate(event.enter)}} | <span style="color:red">KI:</span> {{event.leave?trimDate(event.leave):'-'}}<br/></section>
                  </td>
                </tr>
                <tr>
                  <td><b>Összesen:</b></td>
                  <td></td>
                  <td></td>
                  <td><b>{{month.spent_min}}</b></td>
                  <td><b>{{month.spent_hour}}</b></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
import Vue from 'vue';
import JSONFormatter from 'json-formatter-js';

export default {
  components: {
  },

  computed: {
    curr_year: function() {
      return String(new Date().getFullYear());
    },
    curr_month: function() {
      var d = new Date();
      var month = d.getMonth();
      month = String(month+1).padStart(2, '0');
      return month;
    },
  },

  data: function() {
    return {
      query: {
        year: '2020',
        month: '01',
        group: 0,
        worker: 0
      },
      search: {
        years: {
          items: [{
            label: '2020',
            value: '2020'
          },{
            label: '2021',
            value: '2021'
          },{
            label: '2022',
            value: '2022'
          },{
            label: '2023',
            value: '2023'
          },{
            label: '2024',
            value: '2024'
          },{
            label: '2025',
            value: '2025'
          },{
            label: '2026',
            value: '2026'
          },{
            label: '2027',
            value: '2027'
          },{
            label: '2028',
            value: '2028'
          },{
            label: '2029',
            value: '2029'
          },{
            label: '2030',
            value: '2030'
          }],
          selected: '2022'
        },
        months: {
          items: [{
            label: 'január',
            value: '01'
          },{
            label: 'február',
            value: '02'
          },{
            label: 'március',
            value: '03'
          },{
            label: 'április',
            value: '04'
          },{
            label: 'május',
            value: '05'
          },{
            label: 'június',
            value: '06'
          },{
            label: 'július',
            value: '07'
          },{
            label: 'augusztus',
            value: '08'
          },{
            label: 'szeptember',
            value: '09'
          },{
            label: 'október',
            value: '10'
          },{
            label: 'november',
            value: '11'
          },{
            label: 'december',
            value: '12'
          }],
          selected: '01'
        },
        groups: {
          items: [{
            label: '- válasszon -',
            value: 0
          }],
          selected: 0
        },
        workers: {
          items: [{
            label: '- válasszon -',
            value: 0
          }],
          selected: 0
        },
      },
      days: [],
      month: []
    }
  },

  watch: {
    '$route': 'routerChange'
  },

  created: function() {
    this.routerChange();
  },

  mounted: function() {
    var _this = this;

    this.getGroups();
  },

  methods: {
    routerChange: function() {
      var _this = this;

      if (Object.keys(this.$route.query).length != 0) {
        // Lementi az url paraméterben átadott keresési értékeket
        this.query = JSON.parse(JSON.stringify(this.$route.query));

        this.search.type.selected = this.query.type;

      } else {
        this.query = {
          year: _this.curr_year,
          month: _this.curr_month,
          group: 0,
          worker: 0
        };
      }
    },

    trimDate: function(data){
      var tmp = data.split(" ");
      return tmp[1];
    },

    getGroups: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('worktime_groups/' + _this.$root.user.apikey, {
          success: function(response) {
            _this.search.groups.items = response.groups;
            _this.query.group = response.groups[0].value;
            _this.getWorkers();
          }
        });
      });
    },

    getWorkers: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('worktime_workers/' + _this.$root.user.apikey + '/' + _this.query.group, {
          success: function(response) {
            _this.search.workers.items = response.workers;
            _this.query.worker = response.workers[0].value;
          }
        });
      });
    },

    groupChange: function(val) {
      this.query.group = val;
      this.search.workers.selected = 0;
      this.query.worker = 0;
      this.getWorkers();
    },

    workerChange: function(val) {
      this.query.worker = val;
      this.getDays();
    },

    yearChange: function(val) {
      this.query.year = val;
      this.getDays();
    },

    monthChange: function(val) {
      this.query.month = val;
      this.getDays();
    },

    getDays: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('worktime/' + _this.$root.user.apikey, {
          method: 'post',
          data: _this.query,
          success: function(response) {
            _this.days = response.day_datas;
            _this.month = response.month_datas;
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// worktime.vue?924c92ec